import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { months } from "moment";
class OfferOne extends React.Component {
  render() {
    let newData = new Date();
    let month = newData.getMonth();
    let date = newData.getDate();
    let year = newData.getFullYear();

    return (
      <Fragment>
        <section>
          <div className="endles container-fluid px-0">
            <div className="row w-100 mx-auto">
              <div className="col-md-6 col-sm-6 text-center">
                <Link
                  to="/category/furniture"
                  className="d-flex flex-column justify-content-center h-100"
                >
                  <div className="endless-heading mb-md-2">
                    <h3>Endless Room Ideas</h3>
                  </div>
                  <div className="endless-content mb-md-5">
                    <p>
                      Brows and shop products from our most inspiring spaces
                    </p>
                  </div>

                  <div className="endless-btn">
                    <Link
                      to={"category/furniture"}
                      className="endless-room-txt"
                    >
                      <button type="button">Shop inside</button>
                    </Link>
                  </div>
                </Link>
              </div>
              <div className="col-md-6 col-sm-6 px-md-0">
                <span>
                  <LazyLoadImage
                    effect="blur"
                    src="https://sundialinsider.s3.us-east-2.amazonaws.com/410endles.jpg"
                    width="100%"
                    alt=""
                  />
                </span>
              </div>
            </div>
          </div>
        </section>
        <section className="join-our-program mt-4 wrapper-90 max-1600">
          <div className="container-fluid px-0">
            <div className="row">
              <div className="col-md-6 my-3">
                <div className="program-right-card">
                  <div className="program-heading">
                    <h2>Take $50 Off</h2>
                  </div>
                  <div className="program-quote">
                    <h6>
                      your first order of $23 with the Sundial Offer expires
                      on&nbsp; {`${month}/${date + 2}/${year}`}
                      <Link
                        to={`${
                          this.props.getHomeAds &&
                          this.props.getHomeAds[0].adUrl1
                        }`}
                      >
                        Learn More
                        <i className="fa fa-arrow-right pl-1" />
                      </Link>
                    </h6>
                  </div>
                  <div className="bg-less-img">
                    <img
                      src="./assets/images/sofa.png"
                      width="100%"
                      alt="Discover all of todays best saving"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6 my-3">
                <div className="program-right-card">
                  <div className="program-heading">
                    <h2>Take $50 Off</h2>
                  </div>
                  <div className="program-quote">
                    <h6>
                      your first order of $23 with the Sundial Offer expires
                      on&nbsp; {`${month}/${date + 2}/${year}`}
                      <Link
                        to={`${
                          this.props.getHomeAds &&
                          this.props.getHomeAds[0].adUrl1
                        }`}
                      >
                        Learn More
                        <i className="fa fa-arrow-right pl-1" />
                      </Link>
                    </h6>
                  </div>
                  <div className="bg-less-img">
                    <img
                      src="./assets/images/sofa.png"
                      width="100%"
                      alt="Discover all of todays best saving"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="products wrapper-90 max-1600 my-2">
          <div className="container-fluid">
            <div className="row text-center">
              <div className="col-md-3 col-sm-6 my-3">
                <div className="staticCard-icons">
                  <img
                    effect="blur"
                    src="https://sundialinsider.s3.us-east-2.amazonaws.com/107membership-icon.png"
                    width="50%"
                    alt=""
                  />
                  <h4 className="px-3">A New Take On Cash-Back</h4>
                  <p className="px-4">
                    Members get paid cash every time they shop.
                  </p>
                </div>
              </div>
              <div className="col-md-3 col-sm-6 my-3">
                <div className="staticCard-icons">
                  <img
                    effect="blur"
                    src="https://sundialinsider.s3.us-east-2.amazonaws.com/188returns-icon.png"
                    width="50%"
                    alt=""
                  />
                  <h4 className="px-3">Risk-Free Shopping</h4>
                  <p className="px-4">
                    Easy returns on most orders if something's not quite right.
                  </p>
                </div>
              </div>
              <div className="col-md-3 col-sm-6 my-3">
                <div className="staticCard-icons">
                  <img
                    effect="blur"
                    src="https://sundialinsider.s3.us-east-2.amazonaws.com/550shipping%20icon.png"
                    width="50%"
                    alt=""
                  />
                  <h4 className="px-3">Fast & Free Shipping Over $49*</h4>
                  <p className="px-4">
                    Enjoy two-day delivery on thousands of items.
                  </p>
                </div>
              </div>
              <div className="col-md-3 col-sm-6 my-3">
                <div className="staticCard-icons">
                  <img
                    effect="blur"
                    src="https://sundialinsider.s3.us-east-2.amazonaws.com/113selection-icon.png"
                    width="50%"
                    alt=""
                  />
                  <h4 className="px-3">Curated Collection</h4>
                  <p className="px-4">The hottest brands, all in one place.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default OfferOne;
